import ReportDonutChart from "./ReportDonutChart.vue";

export default ReportDonutChart;
